/**
 * Fuente de las cards «por registro» (Registros y detalle de lista propia).
 *
 * `REACT_APP_RECORDS_SOURCE`:
 * - `legacy`: cards armadas en el Front desde `getmylots` + `getmycadparcels`.
 * - `api`: además se pide `GET /getmyrecords` y sus cards reemplazan a las legacy
 *   (portada de UF, silueta, ubicación). Si la API falla (404 sin ruta, 5xx,
 *   red), se queda en `legacy` sin avisar al usuario.
 *
 * Default del código (sin la env): `api` en desarrollo y `legacy` en el build. Los dos
 * workflows (`develop.yml` y `main.yml`) ponen `REACT_APP_RECORDS_SOURCE: 'api'`, así que DEV
 * y PROD usan `api`. Ver docs/maps/registros-record-cards.md.
 */

export const RECORDS_SOURCES = Object.freeze({ API: 'api', LEGACY: 'legacy' });

/**
 * @param {string|undefined|null} raw - valor de la env
 * @param {string} [nodeEnv]
 * @returns {'api'|'legacy'}
 */
export function resolveRecordsSource(raw, nodeEnv = process.env.NODE_ENV) {
  const value = String(raw ?? '').trim().toLowerCase();
  if (value === RECORDS_SOURCES.API || value === RECORDS_SOURCES.LEGACY) return value;
  return nodeEnv === 'development' ? RECORDS_SOURCES.API : RECORDS_SOURCES.LEGACY;
}

export const RECORDS_SOURCE = resolveRecordsSource(process.env.REACT_APP_RECORDS_SOURCE);

export const isRecordsApiSource = (source = RECORDS_SOURCE) => source === RECORDS_SOURCES.API;
